import geoJSON from "@/api/dummygeoJSON";

export const state = {
  weekdays: ["Monday", "Tuesday", "Thursday", "Friday"],
  filterDates: {
    start: "2018-02-01",
    stop: "2018-02-28"
  },
  filterTimes: {
    start: "00:00",
    stop: "23:59"
  },
  apiCallAPI: "",
  filterButtonLoading: false,
  geoJSON,
  measurements: "",
  showMarker: false,
  showChoropleth: false,
  mapCenter: [50.8701345, 9.7019675],
  // markerPosition: [50.8701345, 9.701967],
  toast: "",
  snackbar: false,
  toastTimeout: 6000,
  mapBounds: {},
  points: [],
  heatmapVisible: false,
  heatmapVisiblePoints: 1000,
  drawer: true,
  filterDialog: false,
  markers: [],
  currentMarkerID: 1,
  reviewDialog: false,
  budget: 100000
};
